import { LitElement, html, css } from 'lit';
import { msg,str } from '@lit/localize';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { accessibility,containers,grid,sidebar } from '../../utilities/styles';
import { cardLinks } from '../../utilities/accessibility';
import { dateToMaybeRange, currencyFormatter } from '../../utilities/eventUtilities';
import { arrowBack, arrow } from '../../utilities/icons';
import { EventManager } from '../../utilities/events';
import { AllInLocationListingsConsumer } from '../Utilities/AllInLocationLIstingsConsumer';

export class AllInLocationZones extends AllInLocationListingsConsumer(LitElement) {
    static properties = {
        restUrl: { type: String },
        nonce: { type: String },
        name: { type: String },
        locationID: { type: String },
        locationName: { type: String },
        currentZone: { type: String },
    }

    constructor() {
        super();
    }

    async connectedCallback() {

        super.connectedCallback();
        this.eventManager = new EventManager(this);
        /* await this._fetchAllProvisions();
        await this._fetchEvents(); */
        if(this.currentZone){
            this.zone = this.location.zones.find(z=>z.id==this.currentZone);
        }
        cardLinks(this.shadowRoot);
    }
    
    disconnectedCallback(){
        super.disconnectedCallback();
        this.eventManager.disconnect();
    }

    updated(changedProperties){
        if(changedProperties.has('currentZone')){
            this.zone = this.location.zones.find(z=>z.id==this.currentZone);
        }
    }

    async firstUpdated(){
        cardLinks(this.shadowRoot);
    }

    render() {
        let cards = '';
        if(!this.location){
            return html`<allin-loader></allin-loader>`;
        }
        if(this.location.zones&&this.location.zones.length){
            cards = this.location.zones.map(zone=>{
                if(this.currentZone&&this.currentZone.id==zone.id){
                    return '';
                }
                return html`
                <div class="bg_white card card--event">
                    <div class="container container--threetwo">
                        <img src="${zone.photo1?.publicUrl??'/wp-content/themes/ace/assets/fallback_new.jpeg'}" alt="${zone.photo1?.altText??''}" />
                        ${zone.photo1?.altText?.trim()
                            ? html`<allin-alt-block description="${zone.photo1?.altText??''}" uid="alt_photo1_${zone.id}"></allin-alt-block>`
                            : ''
                        }
                    </div>
                    <div class="card-content">
                        <a href="#" @click=${(e) => { e.preventDefault(); this.handleZoneClick(zone); }} class="card_target follow"><h3>${zone.name}</h3></a>
                        ${arrow}
                    </div>
                </div>`
            });
        }
        else{
            return '';
        }
        let title = cards.length?html`<h2>${msg('Explore ')} ${this.locationName}</h2>`:'';
        if(this.currentZone && cards.length){
            title = html`<h2>${msg('Explore other zones of ')} ${this.locationName}</h2>`;
        }
        return html`
            ${title}
            <div class="grid grid_33 gap cards">    
                ${cards}
            </div>
        `
        ;
    }


    handleZoneClick(zone){
        this.currentZone = zone;
        this._updateContext({currentZone:zone, currentZoneID:zone.id});
    }

    _getAccessibilityIcons(provisions,returnAsArray=false){
        let accessibilityIcons = [];
        let provisionMap = [];
        this.allProvisions?.forEach(prov=>{
            provisionMap = [...provisionMap,...prov.provisions];
        });
        if(provisions&&provisions.length){
            provisions.forEach(prov=>{
                let provision = provisionMap.find(p=>p.id===prov.standardId);

                if(provision?.filterCategory&&!accessibilityIcons.includes(provision?.filterCategory)){
                    accessibilityIcons.push(provision?.filterCategory);
                }
            });
        }
        accessibilityIcons.sort();
        if(returnAsArray){
            accessibilityIcons = accessibilityIcons.map(cat=>{
                let icon = this.accessibilities?.find(a=>a.name===cat);
                if(icon){
                    return {
                        label:icon.label,
                        icon:icon.icon
                    };
                }
            });
            return accessibilityIcons.filter(icon=>icon);
        }
        accessibilityIcons = accessibilityIcons.map(cat=>{
            let icon = this.accessibilities?.find(a=>a.name===cat);
            if(icon){
                return html`<li class="icon" title="${icon.label}">
                    <span class="screen-reader-text">${msg(str`${icon.label} icon`)}</span>
                    <span aria-hidden="true">
                        ${unsafeHTML(icon.icon??'')}
                    </span>
                </li>`;
            }
        });
        accessibilityIcons = accessibilityIcons.filter(icon=>icon);
        return accessibilityIcons;
    }

    static styles = [
        accessibility,
        grid,
        containers,
        sidebar,
        css`
        .bg{
            padding:var(--allin-padding,2rem);
            background-color:var(--allin-bg-color,#ccc);
            display:grid;
            gap:1rem;
        }
        .small{
            font-size:0.875rem;
        }
        h2{
            color:var(--allin-highlight-color,#472961);
        }

        h3,p{
            margin:0;
        }

        .button-group{
            display:flex;
            justify-content:space-between;
            margin-top:2rem;
        }

        .border-top{
            border-top:1px solid var(--allin-highlight-color,#472961);
            padding-top:2rem;
        }
        .button-group button, .return{
            background-color:transparent;
            color:var(--allin-highlight-color,#472961);
            border:0;
            display:flex;
            gap:0.5rem;
            align-items:center;
            text-decoration:underline;
            cursor:pointer;
            transition:color var(--transition) ease;
            font-weight:700;
            font-size:1rem;

        }
        .return{
            padding:0;
            margin-bottom:2rem;
        }
        .sidebar .return a{
            font-size: 1.25rem;
            font-weight: 700;
        }

        .button-group button svg, .return svg{
            transition:transform var(--transition) ease;
        }
        .button-group button:hover, .return:hover{
            text-decoration-thickness:2px;
        }
        
        .button-group button:hover svg, .return:hover svg{
            transform:rotate(15deg);
        }
        
        ul{
            list-style:none;
            padding:0;
            margin:0;
        }

        button.back{
            color:var(--allin-highlight-color,#472961);
            background-color:transparent;
            border:0;
            padding:0;
            font-weight:700;
            display:flex;
            align-items:center;
            gap:0.5rem;
        }
        button.back span{
            display:flex;
            align-items:center;
            justify-content:center;
            width:1rem;
        }
        button.back svg{
            transform:rotate(0);
            transition:transform var(--transition) ease;
            width:1rem;
        }
        button.back:hover{
            text-decoration:underline;
        }

        button.back:hover svg{
            transform:rotate(15deg);
        }
        @media (prefers-reduced-motion: reduce) {
            button.back svg{
                transform: none !important;
            }
        }
        @media (min-width: 1000px) {
            .two_column{
                grid-template-rows:auto auto auto auto auto;
                grid-auto-flow:dense;
                column-gap:4rem;
            }
            aside{ 
                grid-row:1 / -1;
                grid-column:2 / 3;
            }
        }

        .card{
            background-color:#fff;
            display:grid;
            grid-template-rows:auto 1fr;
            img{
                transition:opacity var(--transition) ease;
            }
        }

        .card .card-content>svg{
            transition:transform var(--transition) ease;
            display:block;
            margin-left:auto;
        }

        .card-content{
            padding:1rem;
        }

        .card a{
            color:var(--allin-highlight-color,#472961);
            text-decoration-gap:0.25rem;
            text-decoration-thickness:1px;
            transition:text-decoration-thickness var(--transition) ease;
        }
        .card:hover img{
            opacity:0.9;
        } 
        /* First link hover effect only if second link is NOT hovered */
        .card:hover .card-content:not(:has(a.follow:hover)) > a.card_target {
            text-decoration-thickness: 2px;
        }

        /* Second link hover effect */
        .card-content a.follow:hover {
            text-decoration-thickness: 2px;
        }

        .card:hover .card-content>svg{
            transform:translateX(0.5rem);
        }

        .card-content{
            display:grid;
            grid-template-rows:auto auto auto 1fr auto;
        }

        .accessibility-icons{
            display:flex;
            gap:0.75rem;
            margin:3rem 0;
            flex-wrap:wrap;
        }
        .accessibility-icons li{
            width:1.5rem;
            height:1.5rem;
            path,circle,rect,polygon{
                fill:var(--allin-highlight-color,#472961);
            }

        }

        .loading{
            position:relative;
        }
        .loading::after{
            content:'';
            position:absolute;
            top:50%;
            left:50%;
            transform:translate(-50%,-50%);
            width:3rem;
            height:3rem;
            border:4px solid var(--allin-highlight-color,#472961);
            border-top-color:transparent;
            border-radius:50%;
            animation:spin 1s linear infinite;
        }

        @keyframes spin {
            to { transform: translate(-50%,-50%) rotate(360deg); }
        }

        .return{
            margin-top:1rem;
        }
        `
        ];
}
